import { render } from "./App.vue?vue&type=template&id=64f2d629"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=64f2d629&lang=scss"

import exportComponent from "M:\\Me\\WebPortfolio_2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__